import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import router from './router';
import store from './store';

Vue.config.productionTip = false

// 挂载全局过滤器
import Filters from './utils/filters'; // 引入过滤器文件  
Vue.use(Filters); // 使用过滤器文件中的过滤器 

// echarts
import 'echarts-gl';
import VueEcharts from "vue-echarts-ts";
Vue.use(VueEcharts);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import "/public/theme.scss";
import "/element-theme.scss";
Vue.use(ElementUI);

// global_css
import './style.scss';


import Print from 'vue-print-nb'
Vue.use(Print)

import html2canvas from "html2canvas"
import JSPDF from "jspdf"



Vue.prototype.ExportSavePdf = (htmlTitle: any, currentTime: any) => {
  var element = document.getElementById("pdfCentent")
  html2canvas(element as any, {
    logging: false,
    // dpi: window.devicePixelRatio * 4,
    scale: 4,
    useCORS: true
  }).then((canvas: any) => {
    var pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
    var ctx = canvas.getContext("2d")
    var a4w = 180; var a4h = 287 // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
    var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
    // var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
    var renderedHeight = 0
    while (renderedHeight < canvas.height) {
      var page: any = document.createElement("canvas")
      page.width = canvas.width
      page.height = Math.min(imgHeight, canvas.height - renderedHeight)// 可能内容不足一页

      // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
      page.getContext("2d").putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)

      pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距

      renderedHeight += imgHeight
      if (renderedHeight < canvas.height) { pdf.addPage() }// 如果后面还有内容，添加一个空页
      // delete page;
    }
    pdf.save(htmlTitle + currentTime)
  })
}

const originalPush: any = Router.prototype.push
Router.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err)
}

new Vue({
  router,
  store,
  render: (h) => {
    return h(App);
  },
}).$mount('#app')
